import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';
import { singleReportHeaderVariables } from '../../components/SingleReportHeader/SingleReportHeaderStyle';

import { breakpoints, colors, fontFamily, zIndex, functions } from '../../ui/variables';


export const WebVisualizerCNNStyle = styled.div`
  box-sizing: border-box;
  overflow: hidden;

  width: 100%;

  &.without-header {
    padding: 32px;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      padding: 32px;
    }
  }

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone +
    singleReportHeaderVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone +
      singleReportHeaderVariables.main.height.ipadLandscape}px;
    }
  }

  #my-iframe {
    width: 100%;
    height: 100%;
    margin: auto;
    position: relative;
  }

  .web-visualizer-modal-container {
    position: absolute;
    background-color: ${colors.black};
    height: 100%;
    padding: 50px 0px 0px 0px;
    width: 100%;
  }

  .web-visualizer-container {
    position: absolute;
    background-color: ${colors.black};
    height: 100%;
    padding: 90px 0 0;
    width: 100%;
  }

  .back-div{
    ${zIndex.sky};
    background-color: ${functions.flattened(
      colors.veryDarkGrayishBlue,
      colors.white,
      0.9
    )};
    color: ${colors.mostlyWhite};
    left: 0;
    padding: 0 20px 4px;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100vw;
  
    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      padding: 0 40px 4px 20px;
    }
  
    .back-link {
      ${fontFamily.sourceSansPro.regular};
      display: inline-block;
      font-size: 14px;
      line-height: 16px;
      padding: 12px 0 12px 32px;
      position: relative;
  
      .icon {
        display: block;
        height: 20px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
  
        svg {
          display: block;
          fill: ${colors.mostlyWhite};
          height: auto;
          width: 100%;
        }
      }
    }
  }
}
`;
